import {RouteDefine} from "./RouteDefine";
import {getSyncEngineVersion} from "../common/helpers/syncEngine";

/**
 * Version-aware settings paths. V1 keeps legacy URLs; V2 uses /settings/*.
 * Use these helpers in shared code instead of hardcoding RouteDefine.settingsEconomic.
 */
export function getSettingsEconomicPath(): string {
    return getSyncEngineVersion() === "v2"
        ? RouteDefine.settingsEconomic
        : RouteDefine.economic;
}

export function getSettingsBusinessPath(): string {
    return getSyncEngineVersion() === "v2"
        ? RouteDefine.settingsBusiness
        : RouteDefine.business;
}

export function getSettingsStripePath(): string {
    return getSyncEngineVersion() === "v2"
        ? RouteDefine.settingsStripe
        : RouteDefine.stripe;
}

const LEGACY_SETTINGS_PATHS = [
    RouteDefine.business,
    RouteDefine.economic,
    RouteDefine.stripe,
] as const;

export function isSettingsPath(pathname: string): boolean {
    if (pathname === RouteDefine.settings || pathname.startsWith(`${RouteDefine.settings}/`)) {
        return true;
    }

    return LEGACY_SETTINGS_PATHS.includes(pathname as typeof LEGACY_SETTINGS_PATHS[number]);
}
